"use client";

import { OurServicesSectionProps } from "@/Templates/SectionsProps";
import { FC } from "react";
import GeneratedOurServicesSection from "../Components/GeneratedOurServicesSection";

const OurServices: FC<OurServicesSectionProps> = (props) => {
  return <GeneratedOurServicesSection {...props} />;
};

export default OurServices;
